<template>
    <header id="header" class="header-main">
        <!--main header menu start-->
        <div id="logoAndNav" class="main-header-menu-wrap fixed-top" style="background:white">
            <div class="container">
                <nav class="js-mega-menu navbar navbar-expand-md header-nav hs-menu-initialized hs-menu-horizontal">

                    <!--logo start-->
                    <a class="navbar-brand pt-0" href="/">
                        <img width="180" src="@/assets/images/logo_main.svg" alt="logo" class="img-fluid">
                    </a>
                    <!--logo end-->

                    <!--responsive toggle button start-->
                    <button type="button" class="navbar-toggler btn" aria-expanded="false" aria-controls="navBar"
                        data-toggle="collapse" data-target="#navBar">
                        <span id="hamburgerTrigger">
                            <span class="ti-menu"></span>
                        </span>
                    </button>
                    <!--responsive toggle button end-->

                    <!--main menu start-->
                    <div id="navBar" class="collapse navbar-collapse">
                        <ul class="navbar-nav ml-auto main-navbar-nav">
                            <li class="nav-item custom-nav-item">
                                <a class="nav-link custom-nav-link" href="#fonction">Fonctionnalités</a>
                            </li>

                            <!-- <li class="nav-item custom-nav-item">
                                <a class="nav-link custom-nav-link" href="#secur">Securité</a>
                            </li> -->

                            <li class="nav-item custom-nav-item">
                                <a class="nav-link custom-nav-link" href="#avant">Avantages</a>
                            </li>

                            <li class="nav-item custom-nav-item">
                                <a class="nav-link custom-nav-link" href="#Prix">Nos forfaits</a>
                            </li>

                            <!--button start-->
                            <li class="nav-item header-nav-last-item d-flex align-items-center">
                                <a href="/register" class="btn btn-brand-03 animated-btn">
                                    Contactez-nous
                                </a>
                            </li>
                            <!--button end-->
                        </ul>
                    </div>
                    <!--main menu end-->
                </nav>
            </div>
        </div>
        <!--main header menu end-->
    </header>
</template>

<script>
export default {

}
</script>

<style>
</style>